export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8330.eba64d25.jpg";